import styled from 'styled-components';

export const Styled = styled.article`
  display: flex;
`;
